/* eslint-disable no-unused-vars */
export enum StationType {
  UNKNOWN = '',
  SELF = '自营站点',
  THIRD = '第三方站点',
}

export enum GridSideType {
  UNKNOWN = '',
  LEFT = '左侧',
  RIGHT = '右侧',
}

export enum GridState {
  UNKNOWN = '',
  OPENED = '开启中',
  CLOSED = '关闭',
}

export enum StopStatus {
  CURRENT = 0,
  ARRIVED = 1,
  UNARRIVED = 2,
}

export enum ScheduleState {
  UNKNOWN = '',
  CREATING = '创建中',
  CONFIRM = '已确认',
  EXECUTING = '执行中',
  COMPLETED = '已完成',
  CANCELLED = '已取消',
}

export enum VehicleScheduleState {
  UNKNOWN = '',
  WAITING = '无任务',
  ALREADY = '待出发',
  SETOUT = '去程',
  DELIVERY = '任务中',
  RETURN = '返程',
  ARRIVED = '已到达',
  TOLOAD = '去装载',
  LOADING = '装载中',
  TOUNLOAD = '去卸载',
  UNLOADING = '卸载中',
  INITIAL = '待分配',
  ASSIGNED = '已分配',
  COLLECTING = '揽收中',
}

export enum VendingVehicleScheduleState {
  WAITING = '准备中',
  ALREADY = '准备中',
  SETOUT = '去程',
  DELIVERY = '售卖中',
  UNKNOWN = '',
}
export enum OrderDeliveryState {
  UNKNOWN = '',
  MISSLOAD = '超时未装载',
  WAITING = '待装载',
  ALREADY = '已装载',
  SETOUT = '去程',
  DELIVERY = '投递中',
  COMPLETED = '已妥投',
  OVERDUE = '超时未取',
  CANCEL = '取消配送',
  UNLOAD = '已卸载',
  MISSUNLOAD = '超时未卸载',
  USERCANCEL = '用户取消',
  // DELETE = '删除',
  // 揽收相关
  TODROPOFF = '揽收中',
  ASSIGNED = '已分配',
  USERDROPPEDOFF = '已揽收',
  CANCELDROPOFF = '取消揽收',
  MISSDROPOFF = '超时未揽收',
  COURIERFETCHED = '揽收已取',
}

export enum StopType {
  UNKNOWN = '',
  START = '起点',
  LOADING = '装载点',
  PICKUP = '取货点',
  HOME = 'HOME点',
  CHARGING = '充电点',
  UPLOADING = '卸载点',
  PARKING = '停车点',
  COLLECTUP = '揽收点',
}

// 停靠点调度状态
export enum StopTravelStatus {
  INIT = 'INIT',
  START = 'START',
  DEPART = 'DEPART',
  SKIP = 'SKIP',
  STAY = 'STAY',
}

export enum ExceptionErrorLevel {
  UNKNOWN = '',
  INFO = '消息',
  WARNING = '警告',
  ERROR = '错误',
  FATAL = '致命异常',
}

export enum PlanningResultCodeType {
  UNKNOWN = '',
  UNKNOWN_TYPE = '未知类型',
  NOTREADY = '未就绪',
  ACTIVE = '活动中',
  ACCOMPLISHED = '已完成',
}

export enum PlanningResultCodeMsg {
  UNKNOWN = '',
  UNKNOWN_MSG = '未知消息',
  OK = '成功',
  RECEIVE_NAVIGATION_COMMAND = '接收到导航指令',
  RECEIVE_MOTION_COMMAND = '接收到控制指令',
  PROCESSING = '处理中',
  FAILED = '失败',
  CANCELLED = '取消',
}

export enum RoutingResultCodeType {
  UNKNOWN = '',
  UNKNOWN_TYPE = '未知类型',
  OK = '成功',
  RECEIVE_NAVIGATION_COMMAND = '接收到导航指令',
  RECEIVE_MOTION_COMMAND = '接收到控制指令',
  PROCESSING = '处理中',
  FAILED = '失败',
  CANCELLED = '取消',
}

export enum RoutingResultCodeMsg {
  UNKNOWN = '',
  UNKNOWN_MSG = '未知消息',
  PROCESSING_SMOTHING = '平滑处理中',
  PROCESSING_ROUTE = '路径计算中',
  FAILED_START_TOO_FAY_AWAY_FROM_LANE = '起点距离道路过远',
  FAILED_END_TOO_FAY_AWAY_FROM_LANE = '终点距离道路过远',
}

export enum LaneTurnType {
  UNKNOWN = '',
  UNKNOWN_TURN = '未知类型',
  STRAIGHT = '直道',
  RIGHT_TURN = '右转车道',
  LEFT_TURN = '左转车道',
  U_TURN = '掉头车道',
  RIGHT_FRONT = '右前车道',
  RIGHT_REAR = '右后车道',
  LEFT_FRONT = '左前车道',
  LEFT_REAR = '左后车道',
}

export enum IntersectionState {
  UNKNOWN = '',
  IN_INTERSECTION = '路口中',
  NEAR_INTERSECTION = '接近路口',
  FAR_FROM_INTERSECTION = '离路口远',
}

export enum SystemState {
  UNKNOWN = '',
  OFFLINE = '离线',
  NORMAL = '正常',
  SELF_REPAIR = '自修复中',
  MALFUNCTION = '系统故障',
  CONNECTION_LOST = '失联',
}

export enum VehicleState {
  UNKNOWN = '',
  INITIALIZATION = '初始化',
  READY = '无任务待机',
  AUTO_DRIVE = '自动驾驶',
  ABNORMAL_STOP = '异常停车',
  REMOTE_CONTROL = '远程控制',
  LOCAL_CONTROL = '手柄控制',
  GUARDIAN_TAKE_OVER = '安全接管',
  EMERGENCY_STOP = '车端拍停',
  CHASSIS_FAULT = '底盘故障停车',
  XBOX_CTRL = 'XBOX控制',
  GUARDIAN_EMERGENCY = '安全急停',
  CHASSIS_STANDBY = '底盘待机',
  BUMPER_STOP = '防撞停车',
  REMOTE_SUPER_CTRL = '强制遥控',
  REMOTE_MOBILE_CTRL = '移动端遥控',
  REMOTE_JOYSTICK_CTRL = '平行驾驶',
  REMOTE_JOYSTICK_SUPER_CTRL = '强制平行驾驶',
}

export enum VehicleHardwareState {
  NORMAL = '正常',
  MAINTENANCE = '保养',
}

export enum RemoteControlState {
  OK = 'OK',
  TIME_EXCEPTION = 'TIME_EXCEPTION',
}

export enum AlarmEventType {
  UNKNOWN = '',
  VEHICLE_STOP_BUTTON = '按钮停车',
  VEHICLE_STOP_FATAL = '异常停车',
  VEHICLE_STOP_GUARDIAN = '安全接管停车',
  VEHICLE_STOP_TIMEOUT = '遇阻停车',
  VEHICLE_CRASH = '防撞',
  LOW_BATTERY = '电量低',
  LOW_PRESSURE = '胎压异常',
  SENSOR_ERROR = '传感器异常',
  OPERATION_ALARM = '运营报警',
  VEHICLE_STOP_TRAFFICLIGHT_FAIL = '感知看灯失败',
  VEHICLE_STOP_INTERSECTION_STUCK = '路口遇阻',
  VEHICLE_STOP_TRAFFICLIGHT_TAKEUP = '看灯点被占',
  VEHICLE_STOP_TRAFFICLIGHT_ADJUST = '看灯规划失败',
  VEHICLE_STOP_STOP_TAKEUP = '停靠点被占',
  VEHICLE_STOP_STOP_ADJUST = '停靠规划失败',
  VEHICLE_CONNECTION_LOST = '车辆失联',
  PASS_NO_SIGNAL_INTERSECTION = '无保护左转',
  BOOT_FAIL = '开机失败',
  BOOT_TIMEOUT = '开机过久',
  STOP_CROSSING_BAR = '过杆遇阻',
  GATE_STUCK = '过门遇阻',
}
export enum Scene {
  stop = 'STOP_AT',
  intersection = 'INTERSECTION',
}

export const sceneNameMap = new Map([
  [Scene.stop, '停靠场景'],
  [Scene.intersection, '路口场景'],
]);
export enum SolutionType {
  UNKNOWN = '',
  RESTART = '重启',
  REMOTE_CONTROL = '远程遥控',
  BACK_TO_CHARGE = '返回充电',
  ON_SITE_REPAIR = '现场处理',
  WAIT_FOR_RESCUE = '等待处理',
  ISSUE_HANDLE = '工单处理',
  AS_ARRIVED = '视同到达',
}

export enum LoginState {
  UNKNOWN = '',
  LOGOUT = 'LOGOUT',
  LOGINING = 'LOGINING',
  LOGINED = 'LOGINED',
  LOGIN_FAILED = ' LOGIN_FAILED',
}

export enum ConnectionState {
  OK = 'CONNECTION_OK',
  LOST = 'CONNECTION_LOST',
}

export enum VehicleUseCaseType {
  TEST = '测试',
  OPERATE = '运营',
}

export enum FetchType {
  NONE = '不拉取数据',
  BASIC_INFO = '基础数据',
  REALTIME_INIT_INFO = '实时数据',
  REALTIME_DETAIL_INFO = '详情数据',
  INIT_OVER = '初始化完成',
}

export enum TaskType {
  NOTASK = 'NOTASK',
  LOADTASK = 'LOADTASK',
  DELIVERY = 'DELIVERY',
  UNLOADTASK = 'UNLOADTASK',
  DROPOFF = 'DROPOFF',
}

export enum TaskTypeText {
  NOTASK = '无任务',
  LOADTASK = '装载',
  DELIVERY = '配送',
  UNLOADTASK = '配送',
  DROPOFF = '揽收',
}

export interface LatLng {
  lat: number;
  lon: number;
}

export interface Grid {
  id: number;
  gridNo: number;
  length: number;
  width: number;
  height: number;
  side: GridSideType;
  state: GridState;
  lockNo: number;
}

export interface Box {
  id: number;
  gridNum: number;
  grid: {
    [id: number]: Grid;
  };
}

export interface Exception {
  errorCode: string;
  errorLevel: ExceptionErrorLevel;
  errorMessage: string;
  recordTimestamp: string;
}

export interface WeelInfoItem {
  wheelPosition: WheelPosition;
  pressureStatus: PressureStatus;
  pressure: number;
}
export interface VehicleStatus {
  lat: number | undefined;
  lon: number | undefined;
  heading: number | undefined;
  speed: number | undefined;
  power: number | undefined;
  deliveryState: VehicleScheduleState;
  systemState: SystemState;
  systemStateMessage: string | undefined;
  vehicleState: VehicleState | undefined;
  vehicleStateMessage: string | undefined;
  alarmEvent:
    | {
        id: number;
        type: AlarmEventType;
        startTimestamp: string;
        solutionType: SolutionType;
      }[]
    | undefined;
  drivable:
    | {
        front: boolean;
        back: boolean;
        left: boolean;
        right: boolean;
      }
    | undefined;
  takeover: {
    userId: number;
    userName: string;
  };
  wheelInfo: WeelInfoItem[] | null;
  issue: Issue[] | null;
}

export interface PncStatus {
  planningResultCodeType: PlanningResultCodeType;
  planningResultCodeMsg: PlanningResultCodeMsg;
  currentLaneTurnType: LaneTurnType;
  trafficLightId: string[];
  passLightAvailable: boolean | null;
  intersectionState: IntersectionState;
  isModifyStance: boolean;
  routingResultCodeType: RoutingResultCodeType;
  routingResultCodeMsg: RoutingResultCodeMsg;
  globalMileage: number;
  traveledMileage: number;
  totalTraveledMileage: number;
  mileageToNextStop: number;
  remainingPower: number;
  powerConsumptionPrediction: number;
  currentStopIndex: number;
  finishedRoutingPoint: {
    lat: number;
    lon: number;
  }[];
  totalRoutingPoint: {
    lat: number;
    lon: number;
  }[];
}

export interface Order {
  orderId: string;
  id: number;
  packageTotal: number;
  deliveryState: OrderDeliveryState;
  contact: string;
  name: string;
  stopName: string;
  gridNoList: number[];
}

export interface Stop {
  id: number;
  number: string;
  name: string;
  lat: number;
  lon: number;
  heading: number;
  type: StopType;
  isArrived: boolean;
  isSkiped: boolean;
  travelStatus: StopTravelStatus;
  arrivedTimestamp: number;
  waitingTime: number;
  departTimestamp: number;
  startTimestamp: number;
  totalOrderNum: number;
  finishedOrderNum: number;
  canceledOrderNum: number;
}

export interface Schedule {
  id: number;
  name: string;
  state: ScheduleState;
  startDatetime: string;
  endDatetime: string;
  finishedOrderNum: number;
  totalOrderNum: number;
  stop: Stop[];
}
export interface Issue {
  vehicleName: string;
  issueNo: string;
  // reportTime: string;
  issueState: IssueState;
  startTime: any;
  operateResultName: string;
  // issueStateName: string;
  // issueType: string;
  // issueTypeName: string;
  // issueSource: string;
  // issueSourceName: string;
}

type IssueState = 'WAITING' | 'PROCESS' | 'FINISH' | 'UNREPORTED' | 'REPORTED';

export enum IssueOperateType {
  SUPPORT_PROCESS = 'SUPPORT_PROCESS',
  DEVELOPER_PROCESS = 'DEVELOPER_PROCESS',
  OPERATOR_PROCESS = 'OPERATOR_PROCESS',
  OPERATION_RESUME = 'OPERATION_RESUME',
  OPERATION_ABORT = 'OPERATION_ABORT',
}
export interface VehicleIssue {
  issueNo: string;
  issueState: IssueState;
}
export interface Organization {
  id: number;
  code: string;
  name: string;
}

export interface User {
  id: number;
  username: string;
  organization: Organization;
  role: object;
  token: string;
}

export interface Login {
  rolePermission: {
    roles: { id: number; name: string }[];
    pagePermissions: { id: number; url: string; method: string }[];
    operationPermissions: { id: number; elementId: string; element: string }[];
  };
  state: LoginState;
  error: string;
  user: User | undefined;
}

export interface OrderType {
  id: number;
  orderId: string;
  originalId: string;
  deliveryState: OrderDeliveryState;
  originDeliveryState: string;
  contact: string;
  name: string;
  stopName: string;
  gridNo: string;
}

export interface OrderListData {
  vehicleName: string;
  taskType: TaskType;
  order: Array<OrderType>;
}

export enum WheelPosition {
  WHEEL_POSITION_NONE = '未知',
  WHEEL_POSITION_FRONT_LEFT = '左前轮',
  WHEEL_POSITION_FRONT_RIGHT = '右前轮',
  WHEEL_POSITION_BACK_LEFT = '左后轮',
  WHEEL_POSITION_BACK_RIGHT = '右后轮',
}

export enum PressureStatus {
  TIRE_PRESSURE_NONE = '胎压未知',
  TIRE_PRESSURE_NORMAL = '胎压正常',
  TIRE_PRESSURE_OVER = '胎压高',
  TIRE_PRESSURE_OVER_LIMIT = '胎压极高',
  TIRE_PRESSURE_UNDER = '胎压低',
  TIRE_PRESSURE_UNDER_LIMIT = '胎压极低',
}

export enum NoSignalInterSectionStatus {
  NONE = 'NONE',
  READY = 'READY',
  RUNNING = 'RUNNING',
  DONE = 'DONE',
}

export interface UserInfo {
  userName: string;
  realName: string;
  companyNumber: string;
  companyName: string;
}

export enum VehicleTag {
  BEIDOU = 1,
  OBU = 2,
  UNKNOWN = 0,
}
